
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import  themen  from 'theme/styles/styled-colors';
import  * as theme  from 'react-syntax-highlighter/dist/esm/styles/hljs';
import SyntaxHighlighter from 'react-syntax-highlighter';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "import-api-options"
    }}>{`Import API Options`}</h1>
    <p>{`Import API options are specified as `}<em parentName="p">{`options`}</em>{` JSON. Since the API accepts multi-part form data, it is possible to specify multiple input streams within the CURL call.`}</p>
    <h3 {...{
      "id": "examples-using-curl-calls"
    }}>{`Examples Using CURL Calls`}</h3>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`curl -g -X POST -u adminuser:password -H "Content-Type: multipart/form-data"
            -H "Cache-Control: no-cache"
            -F request=@importOptions.json
            -F data=@quickStartDB.zip
            "http://localhost:21000/api/atlas/admin/import"`}
    </SyntaxHighlighter>
    <p>{`To use the defaults, set the contents of `}<em parentName="p">{`importOptions.json`}</em>{` to:`}</p>
    <SyntaxHighlighter wrapLines={true} language="json" style={theme.dark} mdxType="SyntaxHighlighter">
      {`{
  "options": {
  }
}`}
    </SyntaxHighlighter>
    <h3 {...{
      "id": "options"
    }}>{`Options`}</h3>
    <p>{`Following options are supported for Import process:`}</p>
    <ul>
      <li parentName="ul">{`Specify transforms during the import operation.`}</li>
      <li parentName="ul">{`Resume import by specifying starting entity guid.`}</li>
      <li parentName="ul">{`Optionally import type definition.`}</li>
      <li parentName="ul">{`Handling large imports.`}</li>
    </ul>
    <h4 {...{
      "id": "transforms"
    }}>{`Transforms`}</h4>
    <p>{`During the import process, the attribute value of the incoming entity can be changed.`}</p>
    <p>{`This is possible by specifying entity type and at attribute to be modified and then the manner in which it needs to be modified.`}</p>
    <p>{`Right now these are the transforms that can be applied:`}</p>
    <ul>
      <li parentName="ul"><em parentName="li">{`lowercase`}</em>{` Converts the attribute value to lower case.`}</li>
      <li parentName="ul"><em parentName="li">{`replace`}</em>{` This performs a string find and replace operation. It takes two parameters, the first is the string to search for and the next one is the string to replace it with.`}</li>
    </ul>
    <p>{`Example:`}</p>
    <p>{`The example below applies a couple of transforms to the `}<em parentName="p">{`qualifiedName`}</em>{` attribute of hive_table. It converts the value to lower case, then searches for 'cl1', if found, replaces it with 'cl2'.`}</p>
    <p>{`To use the option, set the contents of `}<em parentName="p">{`importOptions.json`}</em>{` to:`}</p>
    <SyntaxHighlighter wrapLines={true} language="json" style={theme.dark} mdxType="SyntaxHighlighter">
      {`{
  "options": {
    "transforms": {"hive_table": { "qualifiedName": [ replace:@cl1:@cl2 ] }, "hive_db": { "qualifiedName": [ replace:@cl1:@cl2 ] } }
  }
}`}
    </SyntaxHighlighter>
    <p>{`Please refer to `}<a parentName="p" {...{
        "href": "https://issues.apache.org/jira/browse/ATLAS-1825"
      }}>{`ATLAS-1825`}</a>{` for details scenarios when this option could be used.`}</p>
    <h4 {...{
      "id": "start-guid-or-start-index"
    }}>{`Start Guid or Start Index`}</h4>
    <p>{`When an import operation is in progress and the server goes down, it would be possible to resume import from the last successfully imported entity. This would allow the import to resume from where it left off.`}</p>
    <p>{`Server-side logging is improved to display the detail of the last successfully imported entity, this includes the index within the import list and the entity's guid. Either can be used to specify the point to resume import.`}</p>
    <p>{`To use the option, set the contents of `}<em parentName="p">{`importOptions.json`}</em>{` to:`}</p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`{
  "options": {
    "startGuid": "bd97c78e-3fa5-4f9c-9f48-3683ca3d1fb1"
  }
}`}
    </SyntaxHighlighter>
    <p>{`To use `}<em parentName="p">{`startPosition`}</em>{`, use the following in the `}<em parentName="p">{`importOptions.json`}</em>{`:`}</p>
    <SyntaxHighlighter wrapLines={true} language="json" style={theme.dark} mdxType="SyntaxHighlighter">
      {`{
  "options": {
    "startPosition": "332"
  }
}`}
    </SyntaxHighlighter>
    <p>{`Steps to use the behavior:`}</p>
    <ul>
      <li parentName="ul">{`Start an import (using the CURL) that is fairly long, say about 1000# entities.`}</li>
      <li parentName="ul">{`While the import is in progress, stop atlas server (using atlas_stop.py).`}</li>
      <li parentName="ul">{`From the log file located at `}<em parentName="li">{`/var/log/atlas/application.log`}</em>{` get the last successfully imported entity GUID or index position.`}</li>
      <li parentName="ul">{`Update the `}<em parentName="li">{`importOptions.json`}</em>{` with the guid.`}</li>
      <li parentName="ul">{`Restart import.`}</li>
    </ul>
    <h4 {...{
      "id": "optional-importing-type-definition"
    }}>{`Optional Importing Type Definition`}</h4>
    <p>{`The output of Export has `}<em parentName="p">{`atlas-typedef.json`}</em>{` that contains the type definitions for the entities exported.`}</p>
    <p>{`By default, (that is if no options are specified), the type definitions are imported and applied to the system being imported to. The entity import is performed after this.`}</p>
    <p>{`In some cases, you would not want to modify the type definitions. The import may be better off failing than the types be modified.`}</p>
    <p>{`This option allows for optionally importing of the type definition. The option is set to `}<em parentName="p">{`true`}</em>{` by default, which means that type definition is imported. With this option set to `}<em parentName="p">{`false`}</em>{`, type definitions present in the source will not be imported. In case of mismatch between the entities being imported the types present in the system where the import is being performed, the operation will fail.`}</p>
    <p>{`Table below enumerates the conditions that get addressed as part of type definition import:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Condition`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Action`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Incoming type does not exist in the target system`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Type is created.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Type to be imported and type in the target system are same`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No change`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Type to be imported and type in target system differ by some attributes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Target system type is updated to the attributes present in the source.`}<br />{` It is possible that the target system will have attributes in addition to the one present in the source.`}<br />{` In that case, the target system's type attributes will be a union of the attributes.`}<br />{` Attributes in target system will not be deleted to match the source. `}<br />{`If the type of the attribute differ, the import process will be aborted and exception logged.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`To use the option, set the contents of `}<em parentName="p">{`importOptions.json`}</em>{` to:`}</p>
    <SyntaxHighlighter wrapLines={true} language="json" style={theme.dark} mdxType="SyntaxHighlighter">
      {`{
  "options": {
    "updateTypeDefinition": true
  }
}`}
    </SyntaxHighlighter>
    <h4 {...{
      "id": "specifying-file-to-be-imported-from-server-location"
    }}>{`Specifying File to be Imported From Server Location`}</h4>
    <p>{`In a scenario where the file to be imported is present at a location on the server, the `}<em parentName="p">{`importfile`}</em>{` API can be used. It behaves like the Import API.`}</p>
    <p>{`To use the option, set the contents of `}<em parentName="p">{`importOptions.json`}</em>{` to:`}</p>
    <SyntaxHighlighter wrapLines={true} language="json" style={theme.dark} mdxType="SyntaxHighlighter">
      {`{
  "options": {
    "fileName": "/root/fileToBeImported.zip"
  }
}`}
    </SyntaxHighlighter>
    <p><em parentName="p">{`CURL`}</em></p>
    <SyntaxHighlighter wrapLines={true} language="json" style={theme.dark} mdxType="SyntaxHighlighter">
      {`curl -g -X POST -u adminuser:password -H "Content-Type: application/json"
            -H "Cache-Control: no-cache"
            -d r@importOptions.json
            "http://localhost:21000/api/atlas/admin/importfile"`}
    </SyntaxHighlighter>
    <h4 {...{
      "id": "handling-large-imports"
    }}>{`Handling Large Imports`}</h4>
    <p>{`By default, the Import Service stores all the data in memory. This may be limiting for ZIPs containing a large amount of data.`}</p>
    <p>{`To configure the temporary directory use the application property `}<em parentName="p">{`atlas.import.temp.directory`}</em>{`. If this property is left blank, the default in-memory implementation is used.`}</p>
    <p>{`Please ensure that there is sufficient disk space available for the operation.`}</p>
    <p>{`The contents of the directory created as a backing store for the import operation will be erased after the operation is over.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;